import {getService} from "~/lib/services/services-manager";

export async function getHomePagesList(clientUUID:string){
  const service = getService("server-app");
  const response = await service.get(`/homepage/${clientUUID}/list`);
  return response.data.homepages;
}

export async function initializeHomePage(clientUUID:string, label:string){
  const service = getService("server-app");
  const response = await service.post(`/homepage/${clientUUID}/init`, {label});
  return response.data.homepage;
}

export async function removeHomePage(homePageUUID:string){
  const service = getService("server-app");
  await service.delete(`/homepage/${homePageUUID}`);
}

export async function publishHomePage(homePageUUID:string){
  const service = getService("server-app");
  await service.put(`/homepage/${homePageUUID}/publish`);
}

export async function unPublishHomePage(homePageUUID:string){
  const service = getService("server-app");
  await service.put(`/homepage/${homePageUUID}/unpublish`);
}

export async function saveHomePage(homePageUUID:string, data){
  const service = getService("server-app");
  await service.post(`/homepage/${homePageUUID}`, data);
}

export async function loadHomePageContent(homePageUUID:string){
  const service = getService("server-app");
  const response = await service.get(`/homepage/${homePageUUID}/edit-content`);
  return response.data;
}
